import { createReducer } from '@cld/redux-helpers';
import { CLEAR_MEDIA, ADD_MEDIA, REMOVE_MEDIA } from '../constants/actionTypes';
import { MediaState } from '../types';

export const initialState: MediaState = [];

export default createReducer(
  {
    [ADD_MEDIA]: (
      state: MediaState,
      resp: {
        payload: MediaState;
      }
    ) => [...state, ...resp.payload],
    [REMOVE_MEDIA]: (
      state: MediaState,
      resp: {
        payload: { index: number };
      }
    ) => {
      state.splice(resp.payload.index, 1);
      return state;
    },
    [CLEAR_MEDIA]: () => initialState,
  },
  initialState
);
